module.exports = __webpack_public_path__ + "static/media/hero_7565.14d66ba5.webp";